import { createSlice } from '@reduxjs/toolkit';

import actions from './cart_billing.actions';

import type { CartBilling } from './cart_billing.types';

type CartBillingState = {
  billing: CartBilling | null;
};

const initialState: CartBillingState = { billing: null };

const slice = createSlice({
  name: 'cartBilling',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(actions.get.fulfilled, (state, { payload }) => {
      return { billing: payload };
    });
  },
});

export default slice;
